var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Heading } from '@chakra-ui/react';
import { useMemo } from 'react';
import { NmibleFieldRenderer } from './NmibleFieldRenderer';
export const NmibleObjectField = (_a) => {
    var { title, properties, requiredFields = [], values, errors, onChange } = _a, rest = __rest(_a, ["title", "properties", "requiredFields", "values", "errors", "onChange"]);
    const sortedFields = useMemo(() => Object.entries(properties).sort(([, a], [, b]) => { var _a, _b; return ((_a = a.order) !== null && _a !== void 0 ? _a : 0) - ((_b = b.order) !== null && _b !== void 0 ? _b : 0); }), [properties]);
    const handleFieldChange = (propertyName, value) => {
        onChange(Object.assign(Object.assign({}, values), { [propertyName]: value }));
    };
    return (_jsxs(Box, Object.assign({}, rest, { children: [_jsx(Heading, Object.assign({ as: 'h4', color: 'darkBrandBlue.80', fontSize: 'md', mb: '4' }, { children: title })), _jsx(Flex, Object.assign({ flexWrap: 'wrap', gap: '4' }, { children: sortedFields.map((_a) => {
                    var [fieldName, _b] = _a, { options } = _b, field = __rest(_b, ["options"]);
                    return (_jsx(NmibleFieldRenderer, { field: Object.assign(Object.assign({}, field), { property_name: fieldName, enum: options !== null && options !== void 0 ? options : null, description: null, pattern: null, properties: null, required_fields: null }), isRequired: requiredFields.includes(fieldName), onChange: handleFieldChange, value: values[fieldName], errors: errors }, fieldName));
                }) }))] })));
};
